/**
 * menu-handler-app.js
 */

import React from 'react';
import Icon from 'components/icon';

export default [
  {title: 'Home', route: '/home', icon: <Icon type='home' />},
  {title: 'Records', route: '/records', icon: <Icon type='records' />, disableIE: true},
  {title: 'Groups', route: '/groups', icon: <Icon type='group' />},
  {title: 'Stats', route: '/stats', icon: <Icon type='stats' />},
  {title: 'Profile', route: '/profile', icon: <Icon type='profile' />},
  {title: 'Dogs', route: '/dogs', icon: <Icon type='dog-profile' />},
  {title: 'History', route: '/history', icon: <Icon type='history' />},
  {title: 'Billing', route: '/billing', icon: <Icon type='billing' />},
];